import { useCallback, useState } from "react";

export const useOrgAdmin = () => {
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentOrg, setCurrentOrg] = useState(null); // Store the org being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentOrg(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((org) => {
    setEditMode(true);
    setCurrentOrg(org);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    editMode,
    currentOrg,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  };
};
